import { useState } from 'react'
import Icon from '@web-ui-kit/icon'
import Text from '@web-ui-kit/text'
import PropTypes from 'prop-types'
import * as Sc from './Toggle.style'

const Toggle = ({ dataTestId, onClick, text }) => {
  const [isOpen, setIsOpen] = useState(true)

  const handleOnClick = () => {
    setIsOpen(!isOpen)
    onClick()
  }

  return (
    <Sc.ToggleContainer
      data-testid={dataTestId}
      onClick={handleOnClick}
      type='button'
    >
      <Text variant='buttonSmall'>{text}</Text>
      <Icon
        dataTestId={`icon_${dataTestId}`}
        height={32}
        icon={isOpen ? 'chevronUp' : 'chevronDown'}
        width={32}
      />
    </Sc.ToggleContainer>
  )
}

Toggle.defaultProps = {
  dataTestId: '',
  onClick: () => {},
}

Toggle.propTypes = {
  dataTestId: PropTypes.string,
  onClick: PropTypes.func,
  text: PropTypes.string.isRequired,
}

export default Toggle
